import { render, staticRenderFns } from "./CommonLogin.vue?vue&type=template&id=5dc399b0&"
import script from "./CommonLogin.vue?vue&type=script&lang=ts&"
export * from "./CommonLogin.vue?vue&type=script&lang=ts&"
import style0 from "./CommonLogin.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../sis/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports